import { Link } from "@remix-run/react"
import GuideCard from "../Card/GuideCard"
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper";

const TenantHelpGuide = ({ guides, country }: { guides: any, country: string }) => {
  return (
    <section>
      <p className="text-xl font-bold pb-4 text-center md:text-left mt-10">LEARNING LAB</p>
      <div className="flex justify-between items-end my-6">
        <h2 className="text-lg font-semibold leading-none">Tenant Hub</h2>
        <div className="hidden md:block h-[2px] bg-oh-secondary flex-1 mx-4" />
        <Link
          to={`${getRegionUrlPrefix(country)}/blog/tenants-guides`}
          className="hidden md:block text-sm text-oh-secondary  hover:underline leading-none"
        >
          See more tenant guides
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {guides.map((article: any, idx: number) => (
          <GuideCard country={country} key={idx} article={article} />
        ))}
      </div>
    </section>
  )
}

export default TenantHelpGuide